// extracted by css-extract-rspack-plugin
export default {"bui-FieldError":"Ai9iNkHuNwQ8kqsz"};